// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"4401":"66fec4f0","8723":"f21ff2b9"}[chunkId] || chunkId) + "." + {"2732":"79313ef92eb9add6","3640":"54a16361e4d45636","4401":"7261353a9f902668","5997":"fa01f7fe2422e3c2","6034":"379860fc109064a3","8723":"1c280cdc2e209e31"}[chunkId] + ".js";
};